import { MarkerTrackAdapter } from "./MarkerTrackAdapter";
import { PPQN } from "@opendaw/lib-dsp";
export class TimelineBoxAdapter {
    #box;
    #markerTrack;
    constructor(context, box) {
        this.#box = box;
        this.#markerTrack = new MarkerTrackAdapter(context, this.#box.markerTrack);
    }
    terminate() { }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get markerTrack() { return this.#markerTrack; }
    get signature() {
        return [
            this.#box.signature.nominator.getValue(), this.#box.signature.denominator.getValue()
        ];
    }
    get signatureDuration() {
        const { nominator, denominator } = this.#box.signature;
        return PPQN.fromSignature(nominator.getValue(), denominator.getValue());
    }
    catchupAndSubscribeSignature(observer) {
        observer(this.signature);
        return this.#box.signature.subscribe(() => observer(this.signature));
    }
}
